module.exports = __webpack_public_path__ + "static/media/ic_secure_vault.6118a9af.svg";